import { Head, usePage } from "@inertiajs/react"

import { BehaviorStep } from "@/components/agents/setup/review-responder/behavior-step"
import { ConnectStep } from "@/components/agents/setup/review-responder/connect-step"
import { CustomizationStep } from "@/components/agents/setup/review-responder/customization-step"
import { LaunchStep } from "@/components/agents/setup/review-responder/launch-step"
import {
  STEP_ORDER,
  stepFor,
} from "@/components/agents/setup/review-responder/steps"
import { ToneStep } from "@/components/agents/setup/review-responder/tone-step"
import type {
  GbpConnection,
  ReviewExampleSet,
  ReviewResponderStepProps,
} from "@/components/agents/setup/review-responder/types"
import type { SetupAgent } from "@/components/agents/setup/types"
import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Props {
  agent: SetupAgent
  gbp_connection: GbpConnection
  example_set: ReviewExampleSet | null
}

const STEP_COMPONENTS: Record<
  (typeof STEP_ORDER)[number],
  React.ComponentType<ReviewResponderStepProps>
> = {
  "step-connect": ConnectStep,
  "step-tone": ToneStep,
  "step-behavior": BehaviorStep,
  "step-customization": CustomizationStep,
  "step-launch": LaunchStep,
}

export default function ReviewResponderSetup() {
  const { agent, gbp_connection, example_set } = usePage()
    .props as unknown as Props
  const step = stepFor(agent.setup_step)
  const stepNumber = STEP_ORDER.indexOf(step) + 1
  const totalSteps = STEP_ORDER.length

  const breadcrumbs: BreadcrumbItem[] = [
    { title: agent.archetype.name, href: `/agents/${agent.uid}` },
  ]

  const StepComponent = STEP_COMPONENTS[step]
  const sharedProps: ReviewResponderStepProps = {
    agent,
    stepNumber,
    totalSteps,
    gbpConnection: gbp_connection,
    exampleSet: example_set,
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`${agent.archetype.name} setup`} />
      <StepComponent {...sharedProps} />
    </AppLayout>
  )
}
